<script setup>
import {computed, onBeforeMount, onBeforeUnmount} from 'vue'
import {useStore} from 'vuex'
import {useRoute} from 'vue-router'

import TemplatesList from './TemplatesList.vue'
import {Button} from '@/components/ui/button'
import {PlusCircle} from 'lucide-vue-next'
import CreateTemplateDialog from '@/pages/Project/Templates/CreateTemplateDialog.vue'
import { useCheckProjectAccess } from '@/composables/useCheckAccess'

const route = useRoute()
const projectId = route.params.project_id

const store = useStore()
const project = computed(() => store.getters['project/current'])
const templates = computed(() => {
  const allTemplates = store.getters['geo/getProjectReportTemplates']
  if (!allTemplates) return null
  return [...allTemplates].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
})
const templatesLength = computed(() => templates.value ? templates.value.length : 0)

onBeforeMount(async () => {
  await store.dispatch('project/fetchProject', projectId)
  await store.dispatch('geo/fetchProjectReportTemplates', projectId)
})

onBeforeUnmount(() => {
  store.commit('geo/SET_REPORT_TEMPLATES', null)
})
</script>

<template>
  <div class="mb-1 flex items-center">
    <div class="basis-1/2">
      <h3 class="text-base font-bold">Report Templates ({{templatesLength}})</h3>
    </div>
    <div class="basis-1/2 flex justify-end">
      <CreateTemplateDialog :project-id="Number(projectId)">
        <Button
          class="px-2 text-gray-500 max-w-fit"
          variant="ghost"
          data-testid="create-template-button"
        ><PlusCircle /></Button>
      </CreateTemplateDialog>
    </div>
  </div>
  <TemplatesList v-if="templates" :project="project" :templates="templates" :project-id="Number(projectId)" />
</template>
